import type { RidePoint, RideProgressPlan } from './ride';

const SAMPLE_OFFSETS = [-.12, -.08, -.04, 0, .04, .08, .12] as const;
const SAMPLE_WEIGHTS = [1, 2, 3, 4, 3, 2, 1] as const;

/** A rising side view with a continuous pullback across the recorded terrain. */
export function compileTerrainReveal(route: RideProgressPlan, points: readonly RidePoint[]) {
  let minimum = Infinity;
  let maximum = -Infinity;
  for (const point of points) {
    minimum = Math.min(minimum, point.elevationMeters);
    maximum = Math.max(maximum, point.elevationMeters);
  }
  const elevationRange = Math.max(1, maximum - minimum);
  return (journeyProgress: number) => {
    const progress = Math.min(1, Math.max(0, journeyProgress));
    const reveal = progress * progress * (3 - 2 * progress);
    return {
      bearingOffset: 42 + 40 * reveal,
      pitch: 66 - 12 * reveal,
      zoomOffset: .55 - 1.4 * reveal - .16 * elevationIntensity(route, elevationRange, progress),
    };
  };
}

/** Broad recorded elevation changes add a small response without short zoom reversals. */
function elevationIntensity(route: RideProgressPlan, elevationRange: number, progress: number): number {
  let total = 0;
  let weights = 0;
  for (const [index, offset] of SAMPLE_OFFSETS.entries()) {
    const center = Math.min(1, Math.max(0, progress + offset));
    const before = route.pointNear(Math.max(0, center - .06), progress).elevationMeters;
    const after = route.pointNear(Math.min(1, center + .06), progress).elevationMeters;
    const weight = SAMPLE_WEIGHTS[index]!;
    total += Math.min(1, Math.abs(after - before) / (elevationRange * .45)) * weight;
    weights += weight;
  }
  return total / weights;
}
